import { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import {
  DashboardPage,
  ProjectDetailPage,
  TeamMemberTimelinePage,
  TeamMembersPage,
  LoginPage,
  SprintsPage,
} from './pages';
import { AppLayout } from './components/layout/AppLayout';
import { useAuth } from './hooks/useAuth';
import { Spinner } from './components/ui/Spinner';

function App() {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 5 * 60 * 1000,
            retry: 1,
          },
        },
      })
  );

  const { isLoading, isAuthenticated, user } = useAuth();

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        {isLoading ? (
          <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
            <div className="text-center">
              <Spinner size="lg" />
              <p className="mt-4 text-gray-600">Loading...</p>
            </div>
          </div>
        ) : !isAuthenticated ? (
          <Routes>
            <Route path="*" element={<LoginPage />} />
          </Routes>
        ) : (
          <Routes>
            <Route element={<AppLayout user={user} />}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/projects/:id" element={<ProjectDetailPage />} />
              <Route path="/team-members/timeline" element={<TeamMemberTimelinePage />} />
              <Route path="/team-members" element={<TeamMembersPage />} />
              <Route path="/sprints" element={<SprintsPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        )}
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
